<template>
    <v-alert v-if="visible"
             dense outlined
             type="warning" class="pa-5 mt-4">
        <span v-if="workingontranslations">
            {{ $t('app.translationnotyetavailable', {lang: currentLangName, actuallang: realLangName}) }}
        </span>
        <span v-else>
            {{ $t('app.translationnotavailable', {lang: currentLangName, actuallang: realLangName}) }}
        </span>
    </v-alert>
</template>

<script>
    export default {
        name: "AboutTranslationNotAvailable",
        props: {
            visible: {default: false},
            reallang: {default: 'en'},
            workingontranslations: {default: true},
        },
        computed: {
            currentLangName() {
                return this.languagesMenu[this.currentLang]
            },
            realLangName() {
                return this.languagesMap[this.currentLang][this.reallang]
            }
        }
    }
</script>

<style scoped>

</style>